import styles from "./ProgressBarLoading.module.scss";

type Props = {
  valueProgress: number;
  maxValue: number;
};

export const ProgressBarLoading = ({ valueProgress, maxValue }: Props) => {
  return (
    <progress
      className={styles.progressBar}
      value={valueProgress}
      max={maxValue}
    >
      {valueProgress}%
    </progress>
  );
};
